import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import type { PaginationRequiredQueryInterface } from '@zaoblako/shared/common/dtos/pagination-required-query.dto';
import type { MailingHistoryFindInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-history-find.dto';
import { MailingService } from '@zaoblako/web/core/services/report/mailing.service';
import { UserAvatarComponent } from '@zaoblako/web/shared/components/user-avatar/user-avatar.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { OrderByPipe } from '@zaoblako/web/shared/pipes/order-by.pipe';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TimelineModule } from 'primeng/timeline';

@Component({
  standalone: true,
  selector: 'crm-newsletter-history-widget',
  templateUrl: './newsletter-history-widget.component.html',
  imports: [
    CommonModule,
    CardModule,
    SpinnerComponent,
    ProgressSpinnerModule,
    RouterModule,
    OrderByPipe,
    TimelineModule,
    UserAvatarComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterHistoryWidgetComponent implements OnInit {
  @Input() public newsletterId: number;

  public historyItems: MailingHistoryFindInterface[];
  public queryParamsHistory: PaginationRequiredQueryInterface = {
    limit: 100,
    offset: 0
  };

  public loadingHistory = false;
  public paginationLoadingHistory = false;
  public countItemsHistory: number;

  public constructor(private readonly mailingService: MailingService, private readonly cdRef: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.loadHistory();
  }

  public loadHistory({ concat } = { concat: false }) {
    if (!concat) {
      this.loadingHistory = true;
    }

    this.mailingService.historyById(this.newsletterId, this.queryParamsHistory).subscribe({
      next: (data) => {
        this.queryParamsHistory.limit = data.limit;
        this.queryParamsHistory.offset = data.offset;
        this.countItemsHistory = data.count;
        this.historyItems = concat ? this.historyItems.concat(data.items) : data.items;
        this.paginationLoadingHistory = false;
        this.loadingHistory = false;
        this.cdRef.markForCheck();
      }
    });
  }

  public onScrollEndHistory(target: HTMLElement): void {
    if (target.offsetHeight + target.scrollTop >= target.scrollHeight) {
      if (this.historyItems.length < this.countItemsHistory && !this.loadingHistory && !this.paginationLoadingHistory) {
        this.paginationLoadingHistory = true;
        this.queryParamsHistory.offset += this.queryParamsHistory.limit;
        this.loadHistory({ concat: true });
      }
    }
  }

  public toItem(item: any): MailingHistoryFindInterface {
    return item as MailingHistoryFindInterface;
  }
}
